<template>
  <v-card>
    <v-toolbar class="teal white--text">
      <v-toolbar-title>{{ $t('profile.certs.title') }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon class="white--text" @click.stop="add">
        <v-icon>add</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-list>
        <v-list-tile v-for="item in value.userCertificates" :key="item._self">
          <v-list-tile-content>{{ item.name }}</v-list-tile-content>
          <v-list-tile-action class="mr-3">
            <v-btn icon @click="edit(item)"><v-icon>edit</v-icon></v-btn>
          </v-list-tile-action>
          <v-list-tile-action>
            <v-btn icon @click="remove(item)"><v-icon>delete</v-icon></v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <div class="text-xs-center my-5" v-if="value.userCertificates.length === 0">{{ $t('profile.certs.noCerts') }}</div>

      <certificate-form ref="certForm" @saved="saved" />
    </v-card-text>
  </v-card>
</template>

<script>
import CertificateForm from './CertificateForm'
import UserCertificate from '@/models/UserCertificate'

export default {
  props: ['value'],
  data () {
    return {
      certFormItem: null
    }
  },
  methods: {
    add () {
      this.certFormItem = null
      this.$refs.certForm.show(null)
    },
    saved (cert) {
      if (this.certFormItem === null) {
        this.value.userCertificates.push(cert)
      }
      this.certFormItem = null
    },
    edit (item) {
      this.certFormItem = item
      this.$refs.certForm.show(item)
    },
    remove (item) {
      UserCertificate.delete(item)

      let index = this.value.userCertificates.findIndex(cert => cert._self === item._self)
      if (index >= 0) {
        this.value.userCertificates.splice(index, 1)
      }
    }
  },
  components: {
    CertificateForm
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Certificates.vue?0df49c6a